<div class="  card4   ">
    <div class="">
        <div class="text-sm size15 text-default">Prix public</div>
        <div class=" size24 ">{{ productData.result_ttc }} TND <span
                class="size15 text-muted"> (TTC)</span></div>
        <div class="text-xs size15 text-muted"> {{ productData.result_ht }} TND (HT)</div>
    </div>
</div>
